var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.value,class:[
      'tabs__tab',
      {
        'tabs__tab--selected': _vm.selectedTab === tab.value
      }
    ],on:{"click":function($event){_vm.selectedTab = tab.value}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }